import React from "react";
import { Link } from "react-router-dom";
import themeLarge from "../component/ThemeLarge";
import Footer from "../component/Footer";

import Lottie from "lottie-react";
import Error404 from "../assets/404-error.json"; // path to your downloaded file

const NotFound = () => {
  return (
    <>
      <div style={styles.container}>
        <div style={{ width: 400, margin: "auto" }}>
          <Lottie animationData={Error404} loop={true} />
        </div>
        <p style={styles.text}>
          Sorry, the page you are looking for does not exist.
        </p>
        <Link
          to="/"
          style={{ color: themeLarge.colors.text, textDecoration: "underline" }}
        >
          Go Back to Home
        </Link>
      </div>

      <Footer />
    </>
  );
};

// Inline styles for the component
const styles = {
  container: {
    textAlign: "center",
    height: "90vh",
    paddingTop: "100px",
    background: themeLarge.colors.bg,
  },
  header: {
    fontSize: "48px",
    color: "#333",
  },
  text: {
    fontSize: "18px",
    color: "#777",
  },
  link: {
    fontSize: "18px",
    color: "#007bff",
    textDecoration: "none",
    marginTop: "20px",
    display: "inline-block",
  },
};

export default NotFound;
